import HttpClient from "./http-client";

export interface IBackupHistoryInfo {
  id: string;
  db_backup_master_id: string;
  
  backup_master?: {
    backup_name: string
  };
  start_time: string;
  completed_time?: string;
  status?: string;
  created_on?: string;
}

export default class BackupHistoryServices {
  
  public static async getBackupHistory() {
    const { data } = await HttpClient.get(`db/backup_history/`);
    return data.data;
  }

  public static async getBackupJobHistoryByHistoryId(backupHistoryId: string) {
    try {
      const { data } = await HttpClient.get(`db/backup_history/job/${backupHistoryId}`);
      return data.data;
    } catch (error) {
      console.log(error);
    }
  }

}
